/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import PropTypes from 'prop-types'

const IconMetric = ({ color = '#3C6E90', width = 17, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2H1C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4H16C16.5523 4 17 3.55228 17 3C17 2.44772 16.5523 2 16 2Z"
      fill={color}
    />
    <path
      d="M16 8H1C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10H16C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8Z"
      fill={color}
    />
    <path
      d="M16 14H1C0.447715 14 0 14.4477 0 15C0 15.5523 0.447715 16 1 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14Z"
      fill={color}
    />
    <path
      d="M12 5C12.5523 5 13 4.10457 13 3C13 1.89543 12.5523 1 12 1C11.4477 1 11 1.89543 11 3C11 4.10457 11.4477 5 12 5Z"
      fill={color}
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M7 11C7.55228 11 8 10.1046 8 9C8 7.89543 7.55228 7 7 7C6.44772 7 6 7.89543 6 9C6 10.1046 6.44772 11 7 11Z"
      fill={color}
      stroke={color}
      strokeWidth="0.75"
    />
    <path
      d="M13 17C13.5523 17 14 16.1046 14 15C14 13.8954 13.5523 13 13 13C12.4477 13 12 13.8954 12 15C12 16.1046 12.4477 17 13 17Z"
      fill={color}
      stroke={color}
      strokeWidth="0.75"
    />
  </svg>
)

IconMetric.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
}

export default IconMetric
